export enum ApiStoreKey {
  // Define your API's unique key to access from store here
  location = 'location',
  TermAndConditions = 'term-of-use',
  PrivacyPolicy = 'privacy-policy',
  TeamRoles = 'team-roles',
}
